// @flow
import React from 'react';
import AppMenu from './AppMenu';
import {Col, Collapse} from 'reactstrap';
import QuickSearch from './QuickSearch';

type NavbarProps = {
    isMenuOpened?: boolean,
};

const Navbar = (props: NavbarProps) => {
    return (
        <React.Fragment>
            <div className="topnav">
                <div className="container-fluid">
                    <nav className="navbar navbar-dark navbar-expand-lg topnav-menu">
                        <Collapse isOpen={props.isMenuOpened} className="navbar-collapse" id="topnav-menu-content">
                            <AppMenu />
                        </Collapse>
                        <Col lg={3}>
                            <QuickSearch />
                        </Col>
                    </nav>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Navbar;
